import { render, staticRenderFns } from "./MyResourcesScreen.vue?vue&type=template&id=5a4f0c17&"
import script from "./MyResourcesScreen.vue?vue&type=script&lang=ts&"
export * from "./MyResourcesScreen.vue?vue&type=script&lang=ts&"
import style0 from "./MyResourcesScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports